export enum WhatsAppOnboardingSteps {
  META_BUSINESS_ACCOUNT = 'META_BUSINESS_ACCOUNT',
  PHONE_NUMBER = 'PHONE_NUMBER',
  SETUP_META_BUSINESS_ACCOUNT = 'SETUP_META_BUSINESS_ACCOUNT',
  LOGIN_TO_META = 'LOGIN_TO_META',
  USER_WITH_NO_PHONE_NUMBER = 'USER_WITH_NO_PHONE_NUMBER'
}

export const whatsAppOnboardingStepMapper = {
  [WhatsAppOnboardingSteps.META_BUSINESS_ACCOUNT]: 0,
  [WhatsAppOnboardingSteps.PHONE_NUMBER]: 1,
  [WhatsAppOnboardingSteps.SETUP_META_BUSINESS_ACCOUNT]: 2,
  [WhatsAppOnboardingSteps.LOGIN_TO_META]: 3,
  [WhatsAppOnboardingSteps.USER_WITH_NO_PHONE_NUMBER]: 4
};

export const META_BUSINESS_ACCOUNT_URL = 'https://business.facebook.com/';

export const YAY_URL = 'https://www.yay.com/phone-number/all-numbers/';

export const YAY_GUIDE_URL =
  'https://ludicrous-crocus-952.notion.site/Guide-Purchase-a-new-phone-number-on-YAY-1669aea36879803a871ae1e7122e4c9d';
